/*
 * Constants.
 */

export const globalNamespace = 'global';

/*
 * Helpers.
 */

export function isTeammateNamespace(namespace: string) {
  return namespace.startsWith('tea:');
}

export function isTeamNamespace(namespace: string) {
  return namespace.startsWith('tim:');
}

export function computeIsGlobalNamespace(namespace: string) {
  return namespace === globalNamespace;
}

export function parseTeammateNamespace(namespace: string) {
  return isTeammateNamespace(namespace) ? Number(namespace.slice(4)) : undefined;
}

export function parseTeamNamespace(namespace: string) {
  return isTeamNamespace(namespace) ? Number(namespace.slice(4)) : undefined;
}

/*
 * Application namespace helpers.
 */

interface ApplicationParsedNamespace {
  type: 'teammate' | 'team';
  id: number;
}

export function parseNamespaceForApplication(namespace: string): ApplicationParsedNamespace {
  const teammateId = parseTeammateNamespace(namespace);
  if (teammateId) {
    return {type: 'teammate', id: teammateId};
  }

  const teamId = parseTeamNamespace(namespace);
  if (teamId) {
    return {type: 'team', id: teamId};
  }

  throw new Error(`Unable to parse namespace ${namespace}`);
}
